import { Activity, ExternalLink, Calendar } from 'lucide-react';
import { Button } from '../ui/button';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../ui/select';

export const DashboardHeader = ({ 
  websiteInfo, 
  realTimeUsers = 0,
  timeRange,
  onTimeRangeChange
}) => {
  return (
    <div 
      className="relative overflow-hidden rounded-xl mb-8"
      data-testid="dashboard-header"
    >
      {/* Background image with overlay */}
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://images.unsplash.com/photo-1701664708493-e7a4012bf525?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwyfHxwYW5hbWElMjBjaXR5JTIwcGFuYW1hJTIwbGFuZHNjYXBlJTIwc3Vuc2V0fGVufDB8fHx8MTc3MjI0MzY1NHww&ixlib=rb-4.1.0&q=85')`
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-background via-background/95 to-background/70" />
      
      <div className="relative z-10 p-8">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6">
          <div>
            <div className="flex items-center gap-3 mb-3">
              <h1 className="text-3xl lg:text-4xl font-playfair font-medium text-foreground tracking-tight">
                Analytics Dashboard
              </h1>
              
              {/* Real-time indicator */}
              <div className="flex items-center gap-2 bg-card/80 backdrop-blur-sm border border-white/10 rounded-full px-3 py-1.5">
                <div className="relative">
                  <div className="w-2 h-2 bg-emerald-400 rounded-full" />
                  <div className="absolute inset-0 w-2 h-2 bg-emerald-400 rounded-full animate-pulse-ring" />
                </div>
                <span className="text-sm font-manrope font-medium text-foreground">
                  {realTimeUsers} <span className="text-muted-foreground">active</span>
                </span>
              </div>
            </div>
            
            <div className="flex flex-col sm:flex-row sm:items-center gap-3 text-muted-foreground">
              <span className="font-manrope text-sm">{websiteInfo.name}</span>
              <a 
                href={websiteInfo.url}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-1.5 text-primary hover:text-primary/80 transition-colors text-sm font-manrope group"
                data-testid="website-link"
              >
                <span className="truncate max-w-[250px]">{websiteInfo.url}</span>
                <ExternalLink className="w-3.5 h-3.5 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
              </a>
            </div>
            
            <div className="flex items-center gap-2 mt-3 text-sm text-muted-foreground">
              <Calendar className="w-4 h-4" />
              <span className="font-manrope">Event: {websiteInfo.eventDate} • {websiteInfo.location}</span>
            </div>
          </div>
          
          <div className="flex items-center gap-3">
            <Select value={timeRange} onValueChange={onTimeRangeChange}>
              <SelectTrigger className="w-[160px] bg-card/80 backdrop-blur-sm border-white/10" data-testid="time-range-select">
                <SelectValue placeholder="Select range" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="today">Today</SelectItem>
                <SelectItem value="7days">Last 7 days</SelectItem>
                <SelectItem value="30days">Last 30 days</SelectItem>
                <SelectItem value="90days">Last 90 days</SelectItem>
              </SelectContent>
            </Select>
            
            <Button 
              variant="outline" 
              className="border-white/10 bg-card/80 backdrop-blur-sm hover:bg-primary/10 hover:border-primary/30"
              data-testid="refresh-btn"
            >
              <Activity className="w-4 h-4 mr-2" />
              Refresh
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
